<template>
  <div class="opcl-container">
    <div class="opcl-header">
      <h1>🛠️ 工具中心</h1>
      <p>NoAuth 工具平台 - 新增功能导航</p>
    </div>
    
    <div class="tools-grid">
      <div class="tool-card" @click="$router.push('/opcl/emoji')">
        <div class="tool-icon">😀</div>
        <div class="tool-info">
          <h3>Emoji 搜索</h3>
          <p>输入关键词，快速查找相关 Emoji 表情</p>
        </div>
        <div class="tool-arrow">›</div>
      </div>
      
      <div class="tool-card" @click="$router.push('/opcl/lottery')">
        <div class="tool-icon">🎰</div>
        <div class="tool-info">
          <h3>随机抽奖</h3>
          <p>输入参与人员，一键随机抽取幸运儿</p>
        </div>
        <div class="tool-arrow">›</div>
      </div>
      
      <div class="tool-card" @click="$router.push('/opcl/jsontools')">
        <div class="tool-icon">📋</div>
        <div class="tool-info">
          <h3>JSON 工具</h3>
          <p>JSON 格式化、校验与差异对比</p>
        </div>
        <div class="tool-arrow">›</div>
      </div>
      
      <div class="tool-card" @click="$router.push('/opcl/timestamp')">
        <div class="tool-icon">⏰</div>
        <div class="tool-info">
          <h3>时间戳转换</h3>
          <p>Unix 时间戳与日期格式互转</p>
        </div>
        <div class="tool-arrow">›</div>
      </div>
      
      <div class="tool-card" @click="$router.push('/opcl/shorturl')">
        <div class="tool-icon">🔗</div>
        <div class="tool-info">
          <h3>短链接生成</h3>
          <p>生成长链接的短链接，便于分享</p>
        </div>
        <div class="tool-arrow">›</div>
      </div>
      
      <div class="tool-card" @click="$router.push('/opcl/fileshare')">
        <div class="tool-icon">📁</div>
        <div class="tool-info">
          <h3>文件分享</h3>
          <p>拖拽上传文件，生成分享链接</p>
        </div>
        <div class="tool-arrow">›</div>
      </div>
    </div>
    
    <!-- 其他工具入口 -->
    <div class="other-tools">
      <h2>📦 其他工具</h2>
      <div class="other-links">
        <el-link type="primary" @click="$router.push('/websiteinfo')">网站信息查询</el-link>
        <el-link type="primary" @click="$router.push('/calWorkHours')">工时计算</el-link>
        <el-link type="primary" @click="$router.push('/qrcode')">二维码生成</el-link>
        <el-link type="primary" @click="$router.push('/base64')">Base64 编解码</el-link>
        <el-link type="primary" @click="$router.push('/pinyin')">拼音转换</el-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'opcl'
}
</script>

<style scoped>
.opcl-container {
  padding: 40px;
  max-width: 1400px;
  margin: 0 auto;
}

.opcl-header {
  text-align: center;
  margin-bottom: 50px;
}

.opcl-header h1 {
  font-size: 36px;
  color: #333;
  margin-bottom: 10px;
}

.opcl-header p {
  font-size: 16px;
  color: #888;
}

.tools-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  margin-bottom: 50px;
}

.tool-card {
  display: flex;
  align-items: center;
  background: #fff;
  border-radius: 12px;
  padding: 24px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  border: 1px solid #eee;
}

.tool-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  border-color: #667eea;
}

.tool-icon {
  font-size: 42px;
  margin-right: 20px;
  flex-shrink: 0;
}

.tool-info {
  flex: 1;
}

.tool-info h3 {
  font-size: 18px;
  color: #333;
  margin: 0 0 6px 0;
}

.tool-info p {
  font-size: 14px;
  color: #888;
  margin: 0;
}

.tool-arrow {
  font-size: 28px;
  color: #ccc;
  margin-left: 15px;
}

.other-tools {
  background: #f8f9fa;
  border-radius: 12px;
  padding: 30px;
}

.other-tools h2 {
  font-size: 20px;
  color: #333;
  margin-bottom: 20px;
}

.other-links {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
}

.other-links >>> .el-link {
  font-size: 16px;
}

@media (max-width: 768px) {
  .tools-grid {
    grid-template-columns: 1fr;
  }
  
  .opcl-header h1 {
    font-size: 28px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/opcl.vue